import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
import putData from "../services/putData";



const handleFetchAllSlots = async ({date}: any) => {
  const uri = `v1/slots/sites/all?date=${date}`;
  const response = fetchData({ uri });
  return response;
};


const handleFetchSiteSlots = async ({date, site}: any) => {
  const uri = `v1/slots?date=${date}&site=${site}`;
  const response = fetchData({ uri });
  return response;
};



const handleCreateSlots = async (data: any) => {
  const uri = `v1/slots`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateSlot = async ({ data, _id }: any) => {
  const uri = `v1/slots/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleCountSlots = async ({ data, _id }: any) => {
  const uri = `v1/slots/count/all`;
  const response = putData({ data, uri });
  return response;
};

const handleExportSlots = async ({ data, _id }: any) => {
  const uri = `v1/slots/export/all`;
  const response = putData({ data, uri });
  return response;
};

const handleDeleteSlots = async ({ _id }: any) => {
  const uri = `v1/slots/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchAllSlots,
  handleFetchSiteSlots,
  handleCreateSlots,
  handleUpdateSlot,
  handleDeleteSlots,
  handleCountSlots,
  handleExportSlots,
};
